module.exports = __webpack_public_path__ + "images/cv_btn_wide_02_c3d4cc3afedd50619d0c04fa58bbb337.png";